export const FETCH_WELD_HEALTH = 'FETCH_WELD_HEALTH';
export const FETCH_WELD_HEALTH_SUCCESS = 'FETCH_WELD_HEALTH_SUCCESS';
export const FETCH_WELD_HEALTH_FAILURE = 'FETCH_WELD_HEALTH_FAILURE';

export const FETCH_WELD_ANALYTICS_BUNDLE = 'FETCH_WELD_ANALYTICS_BUNDLE';
export const FETCH_WELD_ANALYTICS_BUNDLE_SUCCESS = 'FETCH_WELD_ANALYTICS_BUNDLE_SUCCESS';
export const FETCH_WELD_ANALYTICS_BUNDLE_FAILURE = 'FETCH_WELD_ANALYTICS_BUNDLE_FAILURE';
export const FETCH_WELD_ANALYTICS_BUNDLE_CANCELLED = 'FETCH_WELD_ANALYTICS_BUNDLE_CANCELLED';

export const FETCH_WELD_ANALYTICS_PRODUCTION = 'FETCH_WELD_ANALYTICS_PRODUCTION';
export const FETCH_WELD_ANALYTICS_PRODUCTION_SUCCESS = 'FETCH_WELD_ANALYTICS_PRODUCTION_SUCCESS';
export const FETCH_WELD_ANALYTICS_PRODUCTION_FAILURE = 'FETCH_WELD_ANALYTICS_PRODUCTION_FAILURE';
export const FETCH_WELD_ANALYTICS_PRODUCTION_CANCELLED = 'FETCH_WELD_ANALYTICS_PRODUCTION_CANCELLED';

export const FETCH_WELD_DETAIL = 'FETCH_WELD_DETAIL';
export const FETCH_WELD_DETAIL_SUCCESS = 'FETCH_WELD_DETAIL_SUCCESS';
export const FETCH_WELD_DETAIL_FAILURE = 'FETCH_WELD_DETAIL_FAILURE';

export const TRIGGER_WELD_PIPELINE = 'TRIGGER_WELD_PIPELINE';
export const TRIGGER_WELD_PIPELINE_SUCCESS = 'TRIGGER_WELD_PIPELINE_SUCCESS';
export const TRIGGER_WELD_PIPELINE_FAILURE = 'TRIGGER_WELD_PIPELINE_FAILURE';

export const CLEAR_WELD_ANALYTICS = 'CLEAR_WELD_ANALYTICS';

export const FETCH_INSPECTION_DATA = 'FETCH_INSPECTION_DATA';
export const FETCH_INSPECTION_DATA_SUCCESS = 'FETCH_INSPECTION_DATA_SUCCESS';
export const FETCH_INSPECTION_DATA_FAILURE = 'FETCH_INSPECTION_DATA_FAILURE';

export const FETCH_INSPECTION_PASSES = 'FETCH_INSPECTION_PASSES';
export const FETCH_INSPECTION_PASSES_SUCCESS = 'FETCH_INSPECTION_PASSES_SUCCESS';
export const FETCH_INSPECTION_PASSES_FAILURE = 'FETCH_INSPECTION_PASSES_FAILURE';

export const LIVE_CHECK_ANOMALY = 'LIVE_CHECK_ANOMALY';
export const LIVE_CHECK_ANOMALY_SUCCESS = 'LIVE_CHECK_ANOMALY_SUCCESS';
export const LIVE_CHECK_ANOMALY_FAILURE = 'LIVE_CHECK_ANOMALY_FAILURE';

export const LIVE_CHECK_INDICATION = 'LIVE_CHECK_INDICATION';
export const LIVE_CHECK_INDICATION_SUCCESS = 'LIVE_CHECK_INDICATION_SUCCESS';
export const LIVE_CHECK_INDICATION_FAILURE = 'LIVE_CHECK_INDICATION_FAILURE';

export const LIVE_PREDICT = 'LIVE_PREDICT';
export const LIVE_PREDICT_SUCCESS = 'LIVE_PREDICT_SUCCESS';
export const LIVE_PREDICT_FAILURE = 'LIVE_PREDICT_FAILURE';

export const LIVE_SCORE_PASS = 'LIVE_SCORE_PASS';
export const LIVE_SCORE_PASS_SUCCESS = 'LIVE_SCORE_PASS_SUCCESS';
export const LIVE_SCORE_PASS_FAILURE = 'LIVE_SCORE_PASS_FAILURE';

export const FETCH_PIPELINE_EXECUTIONS = 'FETCH_PIPELINE_EXECUTIONS';
export const FETCH_PIPELINE_EXECUTIONS_SUCCESS = 'FETCH_PIPELINE_EXECUTIONS_SUCCESS';
export const FETCH_PIPELINE_EXECUTIONS_FAILURE = 'FETCH_PIPELINE_EXECUTIONS_FAILURE';
